"use client";

import Footer from "../global/partials/Footer";
import HeaderV2 from "../global/partials/HeaderV2";
import HeroSection from "../pageComponents/anniversary/HeroSection";
import OfferSection from "../pageComponents/anniversary/OfferSection";
import PricingTableSection from "../pageComponents/anniversary/PricingTableSection";
import FeaturesSection from "../pageComponents/anniversary/FeaturesSection";
import FounderSection from "../pageComponents/anniversary/FounderSection";
import { PageAnniversarySchema } from "@/sanity/pages/PageAnniversaryTemplate";
import ScrollingBanner from "../pageComponents/global/ScrollingBanner";
import TestimonialsSectionV2 from "../pageComponents/global/sections/TestimonialsSectionV2";
import CTASection from "../pageComponents/anniversary/CTASection";
import BirthdayTopBanner from "../global/BirthdayTopBanner";
import BirthdayPopUp from "../global/BirthdayPopUp";

export default function PageAnniversaryJSX({
  data,
}: {
  data: PageAnniversarySchema;
}) {
  return (
    <>
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}
      {data?.birthdayBanner?.isActive &&
        !data?.settings?.hideBirthdayBanner && (
          <div className="absolute inset-0 w-full z-[11] h-fit">
            <BirthdayTopBanner
              data={data.birthdayBanner}
              ctaUrl={
                data.bannerCtaLink ??
                "https://checkout.iqcapital.io/products?coupon=50FUNDING"
              }
              language={data.settings?.language}
            />
          </div>
        )}
      {data?.birthdayBanner?.isActive &&
        !data?.settings?.hideBirthdayBanner &&
        data?.showBirthdayPopup !== false && (
          <BirthdayPopUp
            data={data.birthdayBanner}
            ctaUrl={
              data.bannerCtaLink ??
              "https://checkout.iqcapital.io/products?coupon=50FUNDING"
            }
            language={data.settings?.language}
          />
        )}
      <HeroSection data={data} />
      <OfferSection data={data} />

      <ScrollingBanner
        className="bg-[#F4F5F5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      <PricingTableSection data={data} />
      <FeaturesSection data={data} />
      <FounderSection data={data} />
      <ScrollingBanner
        className="bg-[#F4F5F5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      <TestimonialsSectionV2
        className="lg:pt-[10rem]"
        language={data.settings?.language}
        data={{
          ...data,
          testimonialsCards:
            data.testimonialsCardsRef ?? data.testimonialsCards,
        }}
      />
      <CTASection data={data} />
    </>
  );
}
